import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisProjectArchivedIdeasRoute: InvariantJiraRoute = {
	name: 'polaris-project-archived-ideas',
	path: '/jira/polaris/projects/:projectKey/archived-ideas',
	exact: true,
};
